import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import { useDispatch } from 'react-redux';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import { GradientBackground } from '../COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import Tile from '../COMPONENTS/Tile';
import _ from 'lodash';
import { SET_CLUES } from '../REDUX/actions';
import { SIZE_PAGE } from '../../HOME/const';
import * as f from '../logic';
import { CLUES_COLOR, CLUES_NUNBERS, CLUES_HINTS } from '../const';

const CluesPage = () => {
  const dispatch = useDispatch();
  const [clues, setClues] = useState(0);

  const handleClues = () => {
    dispatch({ type: SET_CLUES, clues });
    dispatch({ type: GOTO_PAGE, payload: { page: SIZE_PAGE } });
  };

  const pulseString = useSpring({
    to: { transform: `scale(${clues ? 0.75 : 1})` },
    onRest: () => clues && handleClues(),
    config: { duration: 200 },
  });

  return (
    <div className="page-root">
      <div className="ms-logo-title">{f.renderTitle('Clues', 'mt-title pt-title')}</div>
      <div className="pt-page" style={{ backgroundImage: GradientBackground }}>
        {_.map([CLUES_COLOR, CLUES_NUNBERS, CLUES_HINTS], (op, i) => {
          const style = op === clues ? pulseString : {};
          return (
            <animated.div key={op} className="pt-start-option pt-option" style={style} onClick={() => setClues(i + 1)}>
              {op === CLUES_COLOR ? (
                <>
                  <Tile style={{ marginRight: '5px', gridArea: '1/1' }} width="50" color="rgb(177,51,123)" />
                  {f.renderTitle('Color', 'mt-tilte pt-title pt-text-option')}
                </>
              ) : op === CLUES_NUNBERS ? (
                <>
                  <Tile style={{ marginRight: '5px', gridArea: '1/1' }} width="50" color="rgb(105,51,177)" off="2" />
                  {f.renderTitle('+ Numbers', 'mt-tilte pt-title pt-text-option')}
                </>
              ) : op === CLUES_HINTS ? (
                <>
                  <Tile style={{ marginRight: '5px', gridArea: '1/1' }} width="50" color="rgb(51,123,177)" off="3" hint />
                  {f.renderTitle('+ Hints', 'mt-tilte pt-title pt-text-option')}
                </>
              ) : null}
            </animated.div>
          );
        })}
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

export default CluesPage;
